import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";

import { CiudadDTO, PaisDTO, RegionDTO } from "@DTOS";
import { PaisesService } from "@shared/servicesBackend";
import { CustomState } from "../CustomState";
import { PaisesAcciones } from "./paises.actions";
import { Nilable } from "@shared/utils";

export interface IPaisesState {
    paises: PaisDTO[];
    regiones: Nilable<RegionDTO[]>;
    ciudades: Nilable<CiudadDTO[]>;
}

@State<IPaisesState>({
    name: "paises",
    defaults: {
        paises: [],
        regiones: null,
        ciudades: null
    }
})
@Injectable()
export class PaisesState extends CustomState<IPaisesState> {
    private cargaPaises = false;
    private paises: PaisDTO[];
    private paisRegiones = new Map<number, RegionDTO[]>();
    private regionesCiudades = new Map<number, CiudadDTO[]>();

    constructor(private paisesService: PaisesService) {
        super();
    }

    @Action(PaisesAcciones.Obtener)
    public async obtenerClientes(ctx: StateContext<IPaisesState>) {
        const stateNuevo = this.obtenerNuevoState(ctx);

        if (!this.cargaPaises) {
            this.paises = await this.paisesService.obtenerPaises();

            stateNuevo.paises = [...this.paises];
            this.cargaPaises = true;
        }

        ctx.setState(stateNuevo);
    }

    @Action(PaisesAcciones.ObtenerRegiones)
    public async obtenerRegiones(ctx: StateContext<IPaisesState>, action: PaisesAcciones.ObtenerRegiones) {
        const stateNuevo = this.obtenerNuevoState(ctx);

        if (!this.paisRegiones.has(action.pais.id)) {
            this.paisRegiones.set(action.pais.id, await this.paisesService.obtenerRegiones(action.pais));
        }
        stateNuevo.regiones = this.paisRegiones.get(action.pais.id) ?? [];

        ctx.setState(stateNuevo);
    }

    @Action(PaisesAcciones.ObtenerCiudades)
    public async obtenerCiudades(ctx: StateContext<IPaisesState>, action: PaisesAcciones.ObtenerCiudades) {
        const stateNuevo = this.obtenerNuevoState(ctx);
        if (!this.regionesCiudades.get(action.region.id)) {
            this.regionesCiudades.set(
                action.region.id, await this.paisesService.obtenerCiudades(action.pais, action.region)
            );
        }
        stateNuevo.ciudades = this.regionesCiudades.get(action.region.id) ?? [];
        ctx.setState(stateNuevo);
    }

    @Action(PaisesAcciones.ReiniciarRegiones)
    public reiniciarRegiones(ctx: StateContext<IPaisesState>) {
        const stateNuevo = this.obtenerNuevoState(ctx);
        stateNuevo.regiones = null;
        ctx.setState(stateNuevo);
    }

    @Action(PaisesAcciones.ReiniciarCiudades)
    public reiniciarCiudades(ctx: StateContext<IPaisesState>) {
        const stateNuevo = this.obtenerNuevoState(ctx);
        stateNuevo.ciudades = null;
        ctx.setState(stateNuevo);
    }
}
